// Vendors
import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Components
import { Loader } from '../components';
import { PipCard, FipCard } from './components';

const Dashboard = () => {
  const isFIP = window.wlPipConfig.isFIP;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [projectStatuses, setProjectStatuses] = useState([]);
  const [projectStatusesLoading, setProjectStatusesLoading] = useState([]);

  const cardHref = isFIP ? 'fip/add-equipment' : '/pcrp/add-project/';
  const cardText = isFIP ? 'Add Equipment' : 'Add a Project';
  const action = isFIP ? 'wl_fip_get_applications' : 'wl_pip_get_projects';

  const getProjectStatusesDropdown = () => {
    const statuses = [
      'In Progress',
      'Submitted',
      'Incomplete',
      'Approved',
      'Completed',
      'Inactive'
    ];

    return statuses.map(
      (status, index) =>
        projectStatuses.includes(status) && (
          <option key={index} value={status}>
            {status}
          </option>
        )
    );
  };

  useEffect(() => {
    setLoading(true);

    axios({
      method: 'post',
      url: `${window.wlPipConfig.ajaxUrl}?action=${action}`
    })
      .then(({ data: { success, data } }) => {
        if (success) setData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!data.length) return;

    setProjectStatusesLoading(true);

    let statuses = [];

    data.map(
      ({ status }) => !statuses.includes(status) && statuses.push(status)
    );

    setProjectStatuses([...statuses]);
    setProjectStatusesLoading(false);
  }, [data]);

  return (
    <div className="grid grid--gutter-vertical grid--row-stretch">
      {loading && <Loader />}
      {!loading && data.length > 0 && (
        <>
          <div className="grid__col-xs-12">
            <div
              className={`form__select form__select--lg form__select--no-shadow ${
                projectStatusesLoading ? 'is-loading' : ''
              }`}
            >
              <select
                className="form__input form__input--lg"
                onChange={(event) => setFilter(event.target.value)}
              >
                <option value="">-- Filter by Project Status --</option>
                {getProjectStatusesDropdown()}
              </select>
            </div>
          </div>

          {data.map((card, index) => {
            if (filter && filter !== card.status) return;

            return isFIP ? (
              <FipCard application={card} key={index} />
            ) : (
              <PipCard project={card} key={index} />
            );
          })}
        </>
      )}

      {!loading && (
        <div className="grid__col-xs-12 grid__col-xl-6">
          <a href={cardHref} className="card-project card-project--add-project">
            <div className="card-project__add">{cardText}</div>
          </a>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
